import { Ops } from '@willie/schemas'
import type { TRPCOutputs } from '~/utils/trpc'

export type InstallationProfileRow = TRPCOutputs['ops']['installationProfiles']['list'][number]
type AssemblyProfile = Ops.InstallationProfileSkus.AssemblyProfile
type Sku = Ops.InstallationProfileSkus.Sku
type LoggerMaker = Ops.StationInstallations.LoggerMaker

const { ASSEMBLY_PROFILE_SKUS, SKU_CATALOG, installationProfileAssemblyProfile } = Ops.InstallationProfileSkus

export const ASSEMBLY_PROFILES = Object.keys(ASSEMBLY_PROFILE_SKUS) as AssemblyProfile[]
export const SKUS = Object.keys(SKU_CATALOG) as Sku[]

type ProfileAssembly =
  | { kind: 'mapped'; assemblyProfile: AssemblyProfile }
  | { kind: 'missing' }
  | { kind: 'not-applicable'; loggerMaker: LoggerMaker }

// Only Efento orders are built from SKUs; a profile with no logger maker yet may still become one.
export const profileAssembly = (
  profile: Pick<InstallationProfileRow, 'slug' | 'logger_makers'>
): ProfileAssembly => {
  const assemblyProfile = installationProfileAssemblyProfile(profile.slug)
  if (assemblyProfile) return { kind: 'mapped', assemblyProfile }
  const loggerMaker = Ops.InstallationProfileCatalog.profileLoggerMaker(profile.logger_makers)
  return loggerMaker === null || loggerMaker === 'efento' ? { kind: 'missing' } : { kind: 'not-applicable', loggerMaker }
}

export const profilesByAssemblyProfile = (
  profiles: readonly InstallationProfileRow[]
): Record<AssemblyProfile, InstallationProfileRow[]> =>
  Object.fromEntries(
    ASSEMBLY_PROFILES.map((assemblyProfile) => [
      assemblyProfile,
      profiles.filter((profile) => installationProfileAssemblyProfile(profile.slug) === assemblyProfile)
    ])
  ) as Record<AssemblyProfile, InstallationProfileRow[]>

export const ASSEMBLY_PROFILES_BY_SKU = Object.fromEntries(
  SKUS.map((sku) => [
    sku,
    ASSEMBLY_PROFILES.filter((assemblyProfile) =>
      (ASSEMBLY_PROFILE_SKUS[assemblyProfile] as readonly Sku[]).includes(sku)
    )
  ])
) as Record<Sku, AssemblyProfile[]>
